import { fork } from './io';
import { takeEveryHelper, takeLatestHelper, throttleHelper } from './sagaHelpers';
export function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  return fork.apply(undefined, [takeEveryHelper, patternOrChannel, worker].concat(args));
}
export function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }
  return fork.apply(undefined, [takeLatestHelper, patternOrChannel, worker].concat(args));
}
export function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }
  return fork.apply(undefined, [throttleHelper, ms, pattern, worker].concat(args));
}